import * as React from 'react';

interface MinusIconProps {
    stroke?: string;
}

const MinusIcon: React.FC<MinusIconProps> = ({ stroke = 'var(--primary-color)' }: MinusIconProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12">
            <path stroke={stroke} strokeWidth="2" d="M0 6h12M6 0" />
        </svg>
    );
};

export default React.memo(MinusIcon);
